export const CUSTOMER_FORM = {
  customerFormContainer: document.querySelector('.aafp_customer-form-container') as HTMLElement,
  customerUpdateForm: document.querySelector('#aafp_update-customer') as HTMLFormElement,
  customerCreateForm: document.querySelector('#aafp_add-new-customer') as HTMLFormElement,
  customerName: document.querySelector('#aafp_form-customer-name') as HTMLInputElement,
  customerAccountNumber: document.querySelector('#aafp_form-customer-account-number') as HTMLInputElement,
  customerGallonLimit: document.querySelector('#aafp_form-customer-limit') as HTMLInputElement,
  customerStatus: document.querySelector('#aafp_form-customer-status') as HTMLSelectElement,
  customerFileType: document.querySelector('#aafp_form-customer-file-type') as HTMLSelectElement,
  customerPartner: document.querySelector('#aafp_dropdown-button-partner') as HTMLElement,
  customerPartnerNumber: document.querySelector('#aafp_form-customer-partner-number') as HTMLInputElement,
  customerTable: document.querySelector('.aafp_customer-list') as HTMLElement,
  customerSubmit: document.querySelector('#aafp_customer-submit') as HTMLElement
}

export const CUSTOMER_STATUS = [
  { id: '1', name: 'Active' },
  { id: '0', name: 'Inactive' }
];